import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LdnHttp } from '../core/services';
import { ListRedirectData } from '../common/model/WK.Ladon.Cms.Read.Queries.Lists.FromExternalLink.Model.ListRedirectData';

@Injectable()
export class ExternalLinkService {

    constructor(private http: LdnHttp) {
    }

    public getListForNro(nro: number): Observable<ListRedirectData> {
        return this.http.get(`/Lists/Document/${nro}`);
    }
}